import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { AuthAndACLService } from './authAndACL.service';



@Injectable()
export class AuthAndACLGuard implements CanActivate {

  constructor(private authAndACL: AuthAndACLService, private router: Router, private flashMessagesService: FlashMessagesService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authAndACL.logado()) {
      this.authAndACL.login();
      return false;
    }

    let accessRoles = route.data['accessRoles'];

    if(!this.authAndACL.canAccess(accessRoles)){
      //TODO criar pagina de permissão negada
      this.flashMessagesService.show("Vocẽ não tem permissão de acessar essa pagina.", { cssClass: 'card alert-warning', timeout: 5000 });
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/auth_and_acl/authAndACL.guard.ts